import React, { useEffect, useMemo, useState } from "react"
import Lottie from "react-lottie"
import { Col, Form, Row, Card, Input, Button, Select, Alert, FormInstance } from "antd"
import { useHistory } from "react-router-dom"
import whatsappLottie from "assets/animations/whatsapp.json"
import { useStore, useStoreActions, useStoreState } from "hooks"
import request from "lib/request"
import { endpoints } from "config/endpoints.config"
import toast from "lib/toast"
import { session } from "store"
import EditEntityCustomFields from "pages/crm/contacts/EditEntityCustomFields"
import FormModal from "components-old/forms/FormModal"
import { channelsDef } from "../channels.def"
import { QrCodeIcon } from "components-old/icons"
import { isAldeia } from "hooks/useAldeia"
import StarAlert from "../StarAlert"

const loadingLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: whatsappLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
}

function Step2() {
  return (
    <div>
      <StarAlert className="mt-2 mb-5">
        <span>
          Estamos criando o servidor do seu canal de WhatsApp... Esse processo pode levar até{" "}
          <strong style={{ color: "var(--gray-90)" }}>10 minutos</strong>.<br />
          Após a criação, você será redirecionado para a página do canal para ler o QRCode.
        </span>
      </StarAlert>
      <div className="h-96 fc">
        <div className="absolute top-1/2 left-1/2 rounded-full -translate-x-1/2 -translate-y-1/2 bg-selected-lighter size-40"></div>
        <div className="-mt-12 fc">
          <Lottie options={loadingLottieOptions} height={150} width={150} speed={1} />
        </div>
      </div>
    </div>
  )
}
const getTextsByStep = (step: 0 | 1 | 2) => {
  switch (step) {
    case 0:
      return {
        centerTitle: "Add canal de WhatsApp App",
        description: (
          <span>
            Vamos integrar seu número com o Kinbox. Para isso, coloque uma descrição e digite exatamente o número do seu{` `}
            <strong style={{ color: "var(--content-primary-active)" }}>WhatsApp</strong>.
          </span>
        ),
      }
    case 1:
      return {
        centerTitle: "Criando canal de WhatsApp...",
        description: (
          <span>
            Esse processo pode levar até <strong style={{ color: "var(--gray-90)" }}>10 minutos</strong>.
          </span>
        ),
      }
    case 2:
      return {
        centerTitle: "Conectar canal",
        description: "Leia o QRCode abaixo no WhatsApp do seu celular para conectar.",
      }
  }
}

function AddWhatsApp() {
  const [step, setStep] = useState<0 | 1 | 2>(0)
  const [id, setId] = useState<string>()
  const [form] = Form.useForm()
  const [saving, setSaving] = useState(false)
  const { all: channels } = useStoreState((state) => state.channels)
  const channelActions = useStoreActions((actions) => actions.channels)
  const history = useHistory()
  const { user } = useStore(session)

  const channel = useMemo(() => {
    return channels.find((c) => c.id == id)
  }, [channels, id])

  useEffect(() => {
    if (id && channel?.status != "processing_channel") {
      history.push("/settings/channels/" + id)
    }
  }, [channel?.status])

  return (
    // <SettingsPageSimple
    //     {...props}
    //     title={
    //         getTextsByStep(step)?.centerTitle
    //     }
    //     style={{
    //         maxWidth: 642,
    //     }}
    //     onBack={() => history.push("/settings/channels/new/whatsapp/type")}
    //     tabTitle="Canais > WhatsApp"
    //     backTo="/settings/channels/new/whatsapp/type"
    //     helpText={<span>Conecte-se aos aplicativos de mensagens mais usados pelos seus clientes e responda todos em sua caixa de entrada.</span>}
    // >
    <>
      {!isAldeia && (
        <div
          style={{
            fontSize: 16,
            color: "var(--content-secondary)",
            marginLeft: 5,
            marginBottom: 20,
          }}
        >
          {getTextsByStep(step)?.description}
        </div>
      )}
      {step == 0 && <AddWhatsAppStep0 form={form} setStep={setStep} setId={setId} />}

      {step == 1 && <Step2 />}
      {step == 1 && <div style={{ marginBottom: 80 }} />}
    </>
  )
}

const AddWhatsAppStep0 = (props: { form: FormInstance; setStep: (step: 0 | 1 | 2) => void; setId: (id: string) => void }) => {
  const { user } = useStore(session)
  const history = useHistory()
  const channelActions = useStoreActions((actions) => actions.channels)

  return (
    <div className="h-96 fc">
      <QrCodeIcon className="w-20 opacity-20" />
      <div className="absolute top-1/2 left-1/2 rounded-full -translate-x-1/2 -translate-y-1/2 bg-selected-lighter size-40"></div>
      <FormModal
        form={props.form}
        onSubmit={(model) => {
          if (user.verificationLevel <= 1) {
            toast.error("Necessário validar seu e-mail para criar canais de WhatsApp.")
          } else {
            return request.post(endpoints.WHATSAPP, model).then((response: any) => {
              channelActions.fetchAll({
                limit: 0,
                offset: 0,
                config: {
                  reset: true,
                },
              })
              props.setId(response.data.id)
              props.setStep(1)
            })
          }
        }}
        onBack={() => history.push("/settings/channels/new/whatsapp")}
        defaultValues={{
          version: 3,
        }}
        type="drawer"
        width={600}
        titleOverwrite={
          <span className="flex gap-3 items-center text-lg">
            <div className="size-7">{channelsDef.record["whatsapp"]?.icon}</div>
            Conectar WhatsApp
          </span>
        }
        successMessage="Canal de WhatsApp criado."
        // stickyFooter
        onSubmitSuccess={() => {
          history.push("/settings/channels")
        }}
        okText="Conectar canal"
      >
        <Row gutter={20}>
          <Col span={24}>
            <Form.Item label="Descrição" name="description">
              <Input placeholder="e.g. Número principal" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Número" name="phone">
              <Input placeholder="e.g. +55 99 999999999" />
            </Form.Item>
          </Col>
        </Row>
        <EditEntityCustomFields form={props.form} entity="channel" />
        <Alert
          showIcon
          message={`Evite utilizar uma nova conta (Número novo) para conectar ao WhatsApp Web ou o Kinbox. Isso pode levar ao bloqueio do seu número pelo WhatsApp, pois a plataforma pode confundi-lo com spam. É recomendado "aquecer" o número durante pelo menos uma semana, trocando mensagens diariamente com outros contatos conhecidos.`}
          type="warning"
        />

        <Form.Item name="version" noStyle>
          <div />
        </Form.Item>
      </FormModal>
    </div>
  )
}

export default AddWhatsApp
